import { createContext, useCallback, useContext, useEffect, useMemo } from 'react'

/**
 * DEPRECATED: SSE tabanlı realtime sistem kaldırıldı.
 * Artık TanStack Query'nin refetchInterval mekanizması kullanılıyor.
 * Bu provider geriye uyumluluk için stub olarak bırakıldı.
 */

type RealtimeMessage = {
  topic: string
  user_id: number
  payload: unknown
  published_at: string
}

type RealtimeContextValue = {
  subscribe: (topic: string, handler: (message: RealtimeMessage) => void) => () => void
  isConnected: boolean
}

const RealtimeContext = createContext<RealtimeContextValue | undefined>(undefined)

export function RealtimeProvider({ children }: { children: React.ReactNode }) {
  // SSE kaldırıldı - polling kullanılıyor
  // Bu provider geriye uyumluluk için stub olarak kalıyor

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const subscribe = useCallback<RealtimeContextValue['subscribe']>((topic, handler) => {
    // No-op: SSE subscription artık kullanılmıyor
    return () => {
      // cleanup no-op
    }
  }, [])

  const value = useMemo<RealtimeContextValue>(
    () => ({
      subscribe,
      isConnected: false, // SSE bağlantısı yok
    }),
    [subscribe],
  )

  return <RealtimeContext.Provider value={value}>{children}</RealtimeContext.Provider>
}

export function useRealtime() {
  const context = useContext(RealtimeContext)
  if (!context) {
    throw new Error('useRealtime yalnızca RealtimeProvider içinde kullanılabilir.')
  }
  return context
}

/**
 * @deprecated SSE kaldırıldı, bu hook artık no-op.
 * Veriler TanStack Query refetchInterval ile otomatik güncelleniyor.
 */
export function useRealtimeSubscription(
  topic: string,
  handler: (message: RealtimeMessage) => void,
): void {
  const { subscribe } = useRealtime()

  useEffect(() => {
    return subscribe(topic, handler)
  }, [handler, subscribe, topic])
}
